<template>
  <component :is="tag" :disabled="disabled" class="btn">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    tag: {type: String, default: 'button'},
    disabled: {type: Boolean, default: false},
    nodecor: {type: Boolean, default: false},
    toright: {type: Boolean, default: false}
  }
}
</script>

<style lang="sass">
.btn
  width: fit-content
  display: flex
  align-items: center
  justify-content: center
  height: 54px
  width: 220px
  max-width: 100%
  font-weight: 500
  font-family: 'Montserrat'
  font-size: 16px
  position: relative
  z-index: 1
  white-space: nowrap
  cursor: pointer
  padding: 0 32px
  border: 2px solid colors.$red
  border-radius: 4px
  background: none
  text-decoration: none
  @include for-mob
    width: 150px
  @include from(400px)
    width: 140px
    height: 50px
  @include from(350px)
    width: 120px
    font-size: 14px
    height: 45px
  color: colors.$brown
  &_gray
    border-color: colors.$light
  &_right
    margin-left: auto
  svg
    margin-left: -14px
    margin-right: 30px
  overflow: hidden
  &[disabled]
    pointer-events: none
    opacity: .4
    color: colors.$brown
  &::before
    content: ""
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: -54px
    z-index: -1
    width: calc(100% + 54px)
    transform: skew(45deg) translateX(-100%)
    background-color: colors.$red
    transition: transform .2s ease-out
    transform-origin: 0 0
  &:hover
    color: colors.$notred
  &:hover::before
    transform: skew(45deg)

</style>